var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CertifiedMember"}},[_c('img',{staticClass:"header",attrs:{"src":"img/toVip.jpg"}}),_c('div',{staticClass:"main",on:{"click":_vm.toBuy}},[_c('img',{staticClass:"header",attrs:{"src":"img/button1.jpg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }